const CRAWLER_MARKERS = [
  'googlebot',
  'bingbot',
  'yandexbot',
  'yandexrenderresourcesbot',
  'bytespider',
  'yisouspider',
  'duckduckbot',
  'baiduspider',
  'slurp',
  'facebookexternalhit',
  'linkedinbot',
  'twitterbot',
  'applebot',
  'headlesschrome',
  'semrushbot',
  'petalbot',
  'ahrefsbot',
  'http://www.google.com/bot.html',
];

export default function isCrawler(userAgent) {
  if (!userAgent || typeof userAgent !== 'string') return false;
  const ua = userAgent.toLowerCase();
  if (CRAWLER_MARKERS.some((marker) => ua.includes(marker))) return true;
  return /\b(bot|spider|crawler)\b/.test(ua);
}
